<template>

  <v-container>

    <v-stepper class="elevation-0">

      <v-stepper-items>

        <v-stepper-content step="1">

          <v-card elevation="0">

            <v-card-title class="text-h5 word-break"><strong>Open Burning Emission Regulation Bylaw</strong></v-card-title>

            <v-card-text class="text-body-1">

              <p><strong>What am I required to do?</strong></p>

              <p>Authorization from Metro Vancouver is required before open burning. This tool will help you comply with the <a href="https://metrovancouver.org/services/environmental-regulation-enforcement/air-quality-regulatory-program/open-burning-vegetative-debris" target="_blank">registration requirements</a> of Metro Vancouver Regional District Open Burning Emission Regulation Bylaw No. 1355, 2022 ("Bylaw 1355"). Owners or operators can use it to register or renew registration and pay the appropriate fee before open burning vegetative debris. Registration lasts for a 12-month period on a parcel of land.</p>

              <p>This tool allows operators to register a parcel of land for open burning that they are providing the service to on behalf of the parcel owner(s). The operator will be required to provide the parcel owner's contact information (name and their email, phone number or mailing address) as part of the registration process.  The operator must have consent from the parcel owner to disclose their contact information to Metro Vancouver before entering the information into the tool.</p>

              <p>This information is collected by Metro Vancouver under s. 26(c) of the Freedom of Information and Protection of Privacy Act and will be used to manage your registration for open burning. Should you have any questions about the collection of this personal information please contact the Privacy Officer at <a href="mailto:privacy@metrovancouver.org">privacy@metrovancouver.org</a>.</p>

              <p>If you have any questions, please call 604-432-OBER (6237) or email <a href="mailto:ober@metrovancouver.org">ober@metrovancouver.org.</a></p>

            </v-card-text>

          </v-card>

          <v-layout>

            <v-spacer></v-spacer>

            <v-btn color="primary" @click="register">sign up</v-btn>&nbsp;<v-btn color="primary" @click="login"><v-icon left>mdi-login</v-icon>sign in</v-btn>

          </v-layout>

        </v-stepper-content>

      </v-stepper-items>

    </v-stepper>

  </v-container>

</template>

<script lang="ts">

import Vue from 'vue'

import axios from "axios";

export default Vue.extend({

  name: 'Home',

  async created() {

    // implement security (kick users to form, admins to dashboard)

    try {

      let obj = await axios.get('accounts/get-user-info');

      var tokens = obj.data.split('\t');

      var email = tokens[1];

      var role = tokens[2];

      this.$store.dispatch('updateEmail', email);

      this.$store.dispatch('updateRole', role);

      if (role == 'User') {

        if (this.$route.path != '/Form') this.$router.push('/Form');

      }
      else if (role == 'Admin' || role == 'Officer') {

        if (this.$route.path != '/Dashboard') this.$router.push('/Dashboard');

      }
    }
    catch
    {
      // the user is not signed in (do nothing)
    }

  },

  methods:
      {
        register() {

          this.$router.push('/Register');

        },
        login() {

          if (this.$route.path != '/Login') this.$router.push('/Login');

        }
      }

})

</script>

<style>

.word-break {

  word-break: break-word;

}

p {
  font-family: Nunito;

  font-size: 19px;
}


th > .v-icon {

  color: white !important;

}

</style>
